import { JSX, useEffect, useState } from "react";
import Wrapper from "../../common/uicomponent/wrapper";
import { all_routes } from "../../router/all_routes";
import { user, userDashCard } from "../../core/json/user";
import { FormProvider } from "react-hook-form";
import { userController } from "./controller";
import BranchSelector from "./BranchSelector";
import MenuRightsSelector from "./MenuRightsSelector";
import CenteredLoader from "../../common/component/CenteredLoader";
import { Tooltip } from "react-tooltip";
import BranchSelectorNew from "./BranchSelectorNew";

const UserPage = () => {
  const [dashboardName, setDashboardName] = useState<string | null>(null);
  const route = all_routes;
  const {
    renderFieldWrapper,
    form,
    getSelectOptions,
    sideBarData,
    handleSave,
    location,
    loading,
    enableBranch,
  } = userController();
  const branchOptions = getSelectOptions("branch");
  const accountOptions = getSelectOptions("account");
  const itemOptions = getSelectOptions("item");
  const selectedAccountOptions = getSelectOptions("selectedaccount");
  const optionalFieldOptions = getSelectOptions("optionalField");
  const masterSeriesOptions = getSelectOptions("mastersacc");

  const branchWatch = form.watch("allBranch");
  const accWatch = form.watch("allAccount");
  const grpWatch = form.watch("allItemGrp");
  const saccWatch = form.watch("allSelected");
  // const optionalWatch = form.watch("optionalSelections");
  const opWatch = form.watch("accountOF");
  const msWatch = form.watch("allMasterSeries");
  const userTypeWatch = form.watch("userType");
  const menuRightsWatch = form.watch("menuRights");
  const [showKpiCards, setShowKpiCards] = useState<boolean>(false);

  // useEffect(() => {
  //   if (sideBarData.length > 0) {
  //     const dashboardItem = sideBarData.find((item) => item.MenuID === 99);
  //     const menuRights = menuRightsWatch || [];
  //     if (dashboardItem && menuRights.includes(99)) {
  //       setDashboardName(dashboardItem.Name);
  //     } else {
  //       setDashboardName(null);
  //     }
  //   }
  // }, [sideBarData, menuRightsWatch]);

  useEffect(() => {
  if (sideBarData.length > 0) {
    const menuRights = menuRightsWatch || [];

    // ── Parent: Dashboards (99) ──
    const dashboardItem = sideBarData.find((item) => item.MenuID === 99);
    if (dashboardItem && menuRights.includes(99)) {
      setDashboardName(dashboardItem.Name);
    } else {
      setDashboardName(null);
    }

    // ── Child: KPI Cards (128) ──
    const kpiItem = sideBarData
      .find((item) => item.MenuID === 99)           // Dashboards dhundo
      ?.SubmenuItems?.find((sub: any) => sub.MenuID === 128); // KPI Cards dhundo

    if (kpiItem && menuRights.includes(128)) {      // 128 selected hai?
      setShowKpiCards(true);
    } else {
      setShowKpiCards(false);
    }
  }
}, [sideBarData, menuRightsWatch]);

  const handleReset = () => {
    form.reset({
      name: "",
      userName: "",
      userType: null,
      // accountOptions: null,
      password: "",
      share: 0,
      accountOptions: null,
      allSelected: 0,
      allAccount: 0,
      allBranch: 0,
      allMasterS:0,
      masterSeriesSelection:[],
      export: 0,
      show: 0,
      isActive: 0,
      allItemGrp: 0,
      menuRights: [],
      accountSelections: [],
      branchSelections: [],
      itemSelections: [],
      optionalSelections: [],
      selectedAccountSelections: [],
    });
  };
  console.log("rights", opWatch?.value, accWatch, grpWatch, branchWatch);

  return (
    <Wrapper
      header="Create User"
      subHeader=""
      backLink={route.userlist}
      backLinkState={location}
      backButtonName="User List"
    // ExportR={ExportR}
    // onClick={() => navigate(route.userlist, { state: location })}
    >
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(handleSave)}>
          {loading && <CenteredLoader />}
          <div className="card w-100">
            <div className="card-body">
              <div className="new-employee-field">
                <div className="row">
                  <div className="col-lg-6 col-md-6">
                    {/* {Object.entries(user.properties)
                      .slice(0, 4)
                      .map(([key, field]) => (
                        <div key={key} className="col-lg-12 col-md-12">
                          {renderFieldWrapper(field as any, key)}
                        </div>
                      ))} */}
                    {Object.entries(user.properties)
                      .slice(0, 6)
                      .filter(
                        ([key]) =>
                          key !== "salesman" || userTypeWatch?.value === 3
                      )
                      .map(([key, field]) => (
                        <div key={key} className="col-lg-12 col-md-12">
                          {renderFieldWrapper(field as any, key)}
                        </div>
                      ))}
                    {userTypeWatch?.value !== 1 && (
                      <div className="row">
                        {Object.entries(user.properties)
                          .slice(6)
                          .filter(
                            ([key]) => key !== "allBranch" || enableBranch
                          ) // Conditionally include allBranch
                          .reduce((acc, [key, field], index, array) => {
                            if (index % 2 === 0) {
                              acc.push(
                                <div
                                  key={key}
                                  className="row"
                                  style={{ marginBottom: "1rem" }}
                                >
                                  <div className="col-lg-6 col-md-6 col-6">
                                    {renderFieldWrapper(field as any, key)}
                                  </div>
                                  {array[index + 1] && (
                                    <div className="col-lg-6 col-md-6 col-6">
                                      {renderFieldWrapper(
                                        array[index + 1][1] as any,
                                        array[index + 1][0]
                                      )}
                                    </div>
                                  )}
                                </div>
                              );
                            }
                            return acc;
                          }, [] as JSX.Element[])}
                      </div>
                    )}
                  </div>

                  {userTypeWatch?.value !== 1 && (
                    <div className="col-lg-6 col-md-6">
                      <MenuRightsSelector
                        menuData={sideBarData}
                        setDashboardName={setDashboardName}
                        name="menuRights"
                        label="Menu Access Rights"
                      />
                    </div>
                  )}
                </div>
           

                {/* {dashboardName &&
                  dashboardName !== null &&
                  userTypeWatch?.value !== 1 && ( */}

                  {dashboardName &&
                    dashboardName !== null &&
                    showKpiCards &&             
                    userTypeWatch?.value !== 1 && (
                    <>
                      <h6 className="mb-2">KPI Cards</h6>
                      <div className="card p-2 mb-2">
                        <div className="row">
                          {Object.entries(userDashCard.properties)
                            .filter(([key]) =>
                              userTypeWatch?.value === 3
                                ? ![
                                  "DBFinancialR",
                                  "DBExpenseR",
                                  "DBCriticalLR",
                                  "DBBalanceBR",
                                  "DBBalanceCashR",
                                ].includes(key)
                                : true
                            )
                            .map(([key, field]) => (
                              <div
                                key={key}
                                className="col-lg-2 col-md-4 col-6"
                              >
                                <div
                                  data-tooltip-id={`tooltip-${key}`}
                                  data-tooltip-content={field?.fullName || key}
                                >
                                  {renderFieldWrapper(field as any, key)}
                                </div>
                                <Tooltip id={`tooltip-${key}`} place="top" />
                              </div>
                            ))}
                        </div>
                      </div>
                    </>
                  )}
                {userTypeWatch?.value !== 1 && (
                  // {userTypeWatch?.value !== 1 && enableBranch && (
                  <div className="row">
                    {branchWatch !== 1 && enableBranch && (
                      <div className="col-lg-6 col-md-12">
                        <BranchSelector
                          branches={branchOptions as any}
                          name="branchSelections"
                          label="Branch"
                        />
                      </div>
                    )}
                    {grpWatch !== 1 && (
                      <div className="col-lg-6 col-md-12">
                        <BranchSelector
                          branches={itemOptions as any}
                          name="itemSelections"
                          label="Item"
                        />
                      </div>
                    )}
                    {/* Optional Field */}
                    {opWatch?.value !== 0 && (
                      <div className="col-lg-6 col-md-12">
                        <BranchSelectorNew
                          branches={optionalFieldOptions as any}
                          name="optionalSelections"
                          label="Optional Field"
                        />
                      </div>
                    )}
                    {accWatch !== 1 && (
                      <div className="col-lg-6 col-md-12">
                        <BranchSelector
                          branches={accountOptions as any}
                          name="accountSelections"
                          label="Account"
                        />
                      </div>
                    )}
                    {saccWatch == 1 && (
                      <div className="col-lg-6 col-md-12">
                        <BranchSelector
                          branches={selectedAccountOptions as any}
                          name="selectedAccountSelections"
                          label="Selected Account"
                        />
                      </div>
                    )}
                    {msWatch !== 1 && (
                      <div className="col-lg-6 col-md-12">
                        <BranchSelector
                          branches={masterSeriesOptions as any}
                          name="masterSeriesSelection"
                          label="Master Series"
                        />
                      </div>
                    )}
                  </div>
                )}
                <div className="row">
                  <div className="col-lg-12 col-md-12 d-flex justify-content-end">
                    <button
                      type="button"
                      className="btn btn-secondary mt-3 me-2"
                      onClick={handleReset}
                    >
                      Reset Form
                    </button>
                    <button
                      type="submit"
                      className="btn btn-primary mt-3"
                      disabled={form.formState.isSubmitting}
                    >
                      {form.formState.isSubmitting ? "Saving..." : "Save User"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
    </Wrapper>
  );
};

export default UserPage;
